import http from '../../../../libs/http'
import config from '../../../../config/shops'
export default () => http.get(`${config.api}/configuration`)
